<template>
  <!------------------------ Tablet Screen -------------------------->
  <!------------------------- Start --------------------------------->
  <v-card :loading="loading" elevation="0" class="px-5" v-if="checkBreakPoints">
    <div class="d-flex mt-5">
      <v-text-field
        prepend-inner-icon="mdi-magnify"
        outlined
        height="5px"
        :placeholder="$t('search')"
        dense
        v-model="search"
        @input="resetSearchOnEmpty"
        class="shrink"
      ></v-text-field>
      <v-btn
        :disabled="search.length < 1"
        color="primary"
        height="40"
        width="40"
        max-width="40"
        outlined
        class="ml-8"
        @click="getTabletActivityLogs"
      >
        <v-icon>mdi-filter-outline</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <div class="py-1 title">{{ from }} - {{ to }} of {{ totalLogs }}</div>
      <v-btn
        :disabled="tabletTableOptions.page <= 1"
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        @click="tabletPageChange(false)"
      >
        <v-icon dark> mdi-chevron-left </v-icon>
      </v-btn>
      <v-btn
        :disabled="tabletTableOptions.page >= totalPages"
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        @click="tabletPageChange(true)"
      >
        <v-icon dark> mdi-chevron-right </v-icon>
      </v-btn>
    </div>
    <v-card
      v-for="(item, index) in logData"
      :key="index"
      class="inner-card my-4 py-2 px-4"
      :elevation="0"
      :style="
        index % 2 !== 0 && {
          backgroundColor: 'rgba(243, 243, 243, 0.5)',
        }
      "
    >
      <v-row no-gutters class="my-5" justify="center" align="center">
        <v-col md="6" class="font-weight-bold">{{$t('animal.inseminationData')}}</v-col>
        <v-col md="6">{{ item.createdAt }}</v-col>
      </v-row>
      <v-row no-gutters class="my-5" justify="center" align="center">
        <v-col md="6" class="font-weight-bold">{{$t('animal.nameOfInseminator')}}</v-col>
        <v-col md="6">{{ item.operatorName }}</v-col>
      </v-row>
      <v-row no-gutters class="my-5" justify="center" align="center">
        <v-col md="6" class="font-weight-bold">{{$t('toDo')}}</v-col>
        <v-col md="6">{{ item.activity }}</v-col>
      </v-row>
      <v-row no-gutters class="my-5" justify="center" align="center">
        <v-col md="6" class="font-weight-bold">{{$t('status')}}</v-col>
        <v-col md="6"
          ><v-btn
            outlined
            color="primary"
            rounded
            depressed
            class="primary2bg text-capitalize"
          >
            {{ item.status }}
          </v-btn></v-col
        >
      </v-row>
    </v-card>
  </v-card>
  <!--------------------------End ----------------------------------->
  <div v-else>
    <div class="d-flex mt-5">
      <v-text-field
        prepend-inner-icon="mdi-magnify"
        outlined
        :placeholder="$t('animal.searchByNameActivity')"
        dense
        class="shrink"
        v-model="search"
        @input="resetSearchOnEmpty"
      >
      </v-text-field>
      <v-btn
        :disabled="search.length < 1"
        color="primary"
        height="40"
        width="40"
        max-width="40"
        outlined
        class="ml-8"
        @click="getActivityLogs"
      >
        <v-icon>mdi-filter-outline</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <div class="py-1 title">{{ from }} - {{ to }} {{$t('of')}} {{ totalLogs }}</div>
      <v-btn
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        :disabled="options.page <= 1"
        @click="pageChange(false)"
      >
        <v-icon dark> mdi-chevron-left </v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        :disabled="options.page >= totalPages"
        @click="pageChange(true)"
      >
        <v-icon dark> mdi-chevron-right </v-icon>
      </v-btn>
    </div>
    <v-data-table
      :headers="headers"
      :items="logData"
      :items-per-page="10"
      hide-default-footer
      :loading="loading"
      :loading-text="$t('loadingData')"
      :options.sync="options"
    >
      <template v-slot:item.status="{ item }">
        <v-btn
          outlined
          color="primary"
          rounded
          depressed
          class="primary2bg text-capitalize"
        >
          {{ item.status }}
        </v-btn>
      </template>
      <template v-slot:footer></template>
    </v-data-table>
  </div>
</template>
<script>
import AnimalService from "@/_services/AnimalService";
import moment from "moment";

export default {
  created() {
    const fetchData = async () => {
      this.getActivityLogs();
    };
    if (this.checkBreakPoints) this.getTabletActivityLogs();
    else fetchData();
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  watch: {
    options: {
      handler() {
        this.getActivityLogs();
      },
      deep: true,
    },
  },
  data() {
    return {
      loading: true,
      from: 0,
      to: 0,
      totalLogs: 0,
      totalPages: 1,
      search: "",
      options: {},
      tabletTableOptions: { itemsPerPage: 5, page: 1, sortBy: [] },
      headers: [
        {
          text: this.$t('animal.inseminationDate'),
          align: "start",
          sortable: false,
          value: "createdAt",
        },
        { text: this.$t('animal.nameOfInseminator'), value: "operatorName" },
        { text: this.$t('animal.activity'), value: "activity" },
        { text: this.$t('status'), value: "status" },
      ],
      logData: [],
    };
  },
  methods: {
    getActivityLogs() {
      this.loading = true;
      AnimalService.getActivityLogs(
        this.options,
        this.$route.params.animal_number,
        this.search
      )
        .then((res) => {
          this.logData = res.data.activities.rows;
          this.totalLogs = res.data.activities.total_rows;
          this.logData = this.logData.map((item) => ({
            ...item,
            createdAt: moment(String(item.createdAt)).format("DD/MM/YYYY"),
          }));
          if (res.data.activities.num_rows > 0) {
            this.from = (this.options.page - 1) * this.options.itemsPerPage + 1;
            this.to =
              this.options.page * this.options.itemsPerPage -
              (this.options.itemsPerPage - res.data.activities.num_rows);
            this.totalPages = Math.ceil(
              this.totalLogs / this.options.itemsPerPage
            );
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTabletActivityLogs() {
      this.loading = true;
      AnimalService.getActivityLogs(
        this.tabletTableOptions,
        this.$route.params.animal_number,
        this.search
      )
        .then((res) => {
          this.logData = res.data.activities.rows;
          this.totalLogs = res.data.activities.total_rows;
          if (res.data.activities.num_rows > 0) {
            this.from =
              (this.tabletTableOptions.page - 1) *
                this.tabletTableOptions.itemsPerPage +
              1;
            this.to =
              this.tabletTableOptions.page *
                this.tabletTableOptions.itemsPerPage -
              (this.tabletTableOptions.itemsPerPage -
                res.data.activities.num_rows);
            this.totalPages = Math.ceil(
              this.totalLogs / this.tabletTableOptions.itemsPerPage
            );
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pageChange(t) {
      if (t) this.options.page = this.options.page + 1;
      else this.options.page = this.options.page - 1;

      this.getActivityLogs();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      this.getTabletActivityLogs();
    },
    resetSearchOnEmpty() {
      if (this.search === "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletActivityLogs();
      } else {
        this.options.page = 1;
        this.getActivityLogs();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-data-table-header {
  background: $secondary2-color;
  border-radius: 5px 5px;
}
::v-deep .v-data-table-header span {
  // text-transform: uppercase !important;
  color: black;
}
::v-deep .primary2bg {
  background-color: $green2 !important;
}
</style>